module.exports = " <div class=\"container-fluid no-padding-sides\" _v-176e7160=\"\"> <h2 class=\"title-center no-margin-top no-padding-top\" _v-176e7160=\"\">Inspiración Lasddi</h2> <div class=col-sm-12 _v-176e7160=\"\"> <div class=\"banner-image banner-inspiracion pointer\" :style=\"'background-image: url(' + setUrlImage() + ')'\" v-link=\"{ path: '/proyectos-contract' }\" _v-176e7160=\"\"> </div> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-176e7160!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Banner.vue
// module id = 597
// module chunks = 0